import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import Typography from "@material-ui/core/Typography";
import Toolbar from "@material-ui/core/Toolbar";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Switch from "@material-ui/core/Switch";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import moment from "moment";

import MyButton from "./MyButton";
import SuKienHeaderControl from "./controls/SuKienHeaderControl";
import SuKienTaiNanControl from "./controls/SuKienTaiNanControl";
import SuKienPhuongTienControl from "./controls/SuKienPhuongTienControl";
import SuKienTinhChatControl from "./controls/SuKienTinhChatControl";
import SuKienXuLyControl from "./controls/SuKienXuLyControl";
import SuKienKetQuaControl from "./controls/SuKienKetQuaControl";
import SuKienKetQuaChiTietControl from "./controls/SuKienKetQuaChiTietControl";
import SuKienDinhKemControl from "./controls/SuKienDinhKemControl";
import SuKienDieuDongControl from "./controls/SuKienDieuDongControl";
import SuKienTrucBanControl from './controls/SuKienTrucBanControl';
import AlertDialog from "./AlertDialog";
import ConfirmDialog from "./ConfirmDialog";

const myLib = require("../lib/MyLib");
const server = require("../lib/server");
const sukienLayer = require("../lib/SuKienDataLayer");

class SuKienEditDialog extends React.Component {
  constructor(props) {
    super(props);
    this.handleXoa = this.handleXoa.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleDataChanged = this.handleDataChanged.bind(this);
    this.state = {
      open: props.visible,
      fullWidth: true,
      maxWidth: "xl",
      formReady: false, //trang thai form san sang
      dataSaved: undefined, //du lieu duoc saved
      expandedTainan: false, //co expand control tai nan hay khong
      //quan ly tong so phuong tien
      SoPhuongTien: 0, //so control phuong tien da duoc cap nhat trong DB
      DanhSachPhuongTien: [undefined], //index theo stt bat dau tu 1
      PhuongTien2: false, //cho phep edit phuong tien thu 2 hay khong
      PhuongTien3: false, //cho phep edit phuong tien thu 3 hay khong
      //quan ly dieu dong phuong tien
      SoDieuDong: 0,
      DanhSachDieuDong: [undefined],
      DieuDong2: false,
      DieuDong3: false,
      //danh sach file dinh kem neu co
      DinhKem: [],
      errorLog: "",
      //thoat hay khong
      dataChanged: 0, //du lieu co bi thay doi hay khong
      showCloseConfirm: false,
    };
  }
  handleClickOpen = () => {
    this.setState({ open: true });
  };
  handleXoa = () => {
    //xoa su kien
    server
      .post("sukien/xoa", { MaSK: this.props.MaSK })
      .then((response) => {
        this.handleClose();
      })
      .catch((error) => this.setState({ errorLog: error + "" }));
  };
  handleClose = (show) => {
    if (show && this.state.dataChanged > 0) {
      this.setState({ showCloseConfirm: true });
    } else {
      this.setState({ open: false });
      if (this.props.onClose) {
        this.props.onClose();
      }
    }
  };
  componentDidMount() {
    //kiem tra xem co phai che do edit hay khong
    var mask = this.props.MaSK;
    if (mask !== undefined) {
      //load va hien thi thong tin su kien
      server
        .query("sukien/get?mask=" + mask)
        .then((response) => {
          //thong tin su kien
          var sukien = response.sukien;
          sukien = sukienLayer.chuyenDoi(sukien); //chuyen doi gia tri
          //phuong tien
          var phuongtien = response.phuongtien;
          var list_phuongtien = [undefined];
          if (
            phuongtien != undefined &&
            phuongtien != null &&
            phuongtien.length > 0
          ) {
            phuongtien.map((item, index) => {
              var temp = sukienLayer.chuyenDoiPhuongTien(item);
              list_phuongtien.push(temp);
            });
          }
          //dieu dong phuong tien
          var dieudong = response.dieudong;
          var list_dieudong = [undefined];
          if (
            dieudong != undefined &&
            dieudong != null &&
            dieudong.length > 0
          ) {
            dieudong.map((item, index) => {
              var temp = sukienLayer.chuyenDoiDieuDong(item);
              list_dieudong.push(temp);
            });
          }

          this.setState({
            formReady: true,
            dataSaved: sukien,
            DanhSachPhuongTien: list_phuongtien,
            PhuongTien2: list_phuongtien.length > 2,
            DinhKem: response.dinhkem,
            DanhSachDieuDong: list_dieudong,
            DieuDong2: list_dieudong.length > 2,
          });
          console.log("ket qua truy van", sukien);
        })
        .catch((error) => {
          console.log(error);
          this.setState({ loading_coquan: false });
        });
    } else {
      this.setState({ formReady: true });
    }
  }
  handleDataChanged = (changed) => {
    this.setState({dataChanged: this.state.dataChanged + (changed ? 1 : -1)});
  }
  static getDerivedStateFromProps(props, state) {
    return { ...state };
  }
  render() {
    const { classes, theme } = this.props;
    return (
      <React.Fragment>
        <Dialog
          fullWidth={this.state.fullWidth}
          maxWidth={this.state.maxWidth}
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="max-width-dialog-title"
        >
          <DialogTitle id="max-width-dialog-title">
            <AppBar position="static">
              <Toolbar>
                <IconButton
                  edge="start"
                  className={classes.menuButton}
                  color="inherit"
                  aria-label="menu"
                >
                  <MenuIcon />
                </IconButton>
                <Typography variant="h6" className={classes.title}>
                  Thông tin sự vụ
                </Typography>
                {this.props.EditMode === "xoa" ? (
                  <Button color="inherit" onClick={this.handleXoa}>
                    Xóa sự vụ
                  </Button>
                ) : null}
                <Button color="inherit" onClick={() => this.handleClose(true)}>
                  Thoát
                </Button>
              </Toolbar>
            </AppBar>
          </DialogTitle>
          <DialogContent>
            <form className={classes.form} noValidate autoComplete="off">
              {this.state.formReady ? (
                <SuKienHeaderControl
                  value={this.state.dataSaved}
                  onSaved={(data) => {
                    this.setState({ dataSaved: data, expandedTainan: true });
                    console.log("data saved:", data);
                  }}
                  onChanged = {this.handleDataChanged}
                />
              ) : null}
              {this.state.formReady ? (
                <SuKienTaiNanControl
                  disabled={this.state.dataSaved === undefined}
                  value={this.state.dataSaved}
                  expanded={this.state.expandedTainan}
                  onChanged = {this.handleDataChanged}
                />
              ) : null}
              {this.state.formReady ? (
                <SuKienPhuongTienControl
                  disabled={this.state.dataSaved === undefined}
                  value={
                    this.state.DanhSachPhuongTien[1] === undefined
                      ? this.state.dataSaved
                      : this.state.DanhSachPhuongTien[1]
                  }
                  stt={1}
                  onSaved={(data) => {
                    var has = false;
                    this.state.DanhSachPhuongTien[1] = data;
                    this.setState(this.state);
                  }}
                  allowAddMore={
                    this.state.DanhSachPhuongTien[1] !== undefined &&
                    !this.state.PhuongTien2
                  }
                  onAddMore={(stt) => {
                    this.setState({ PhuongTien2: true });
                  }}
                  onChanged = {this.handleDataChanged}
                />
              ) : null}
              {this.state.PhuongTien2 ? (
                <SuKienPhuongTienControl
                  disabled={this.state.dataSaved === undefined}
                  value={
                    this.state.DanhSachPhuongTien[2] === undefined
                      ? this.state.dataSaved
                      : this.state.DanhSachPhuongTien[2]
                  }
                  stt={2}
                  onSaved={(data) => {
                    this.state.DanhSachPhuongTien[2] = data;
                    this.setState(this.state);
                  }}
                  onRemoved={(stt) => {
                    //xoa control
                    this.setState({ PhuongTien2: false });
                  }}
                  onChanged = {this.handleDataChanged}
                />
              ) : undefined}
              {this.state.formReady ? (
                <SuKienTinhChatControl
                  disabled={this.state.dataSaved === undefined}
                  value={this.state.dataSaved}
                  onChanged = {this.handleDataChanged}
                />
              ) : null}
              {this.state.formReady ? (
                <SuKienXuLyControl
                  disabled={this.state.dataSaved === undefined}
                  value={this.state.dataSaved}
                  onChanged = {this.handleDataChanged}
                />
              ) : null}
              {this.state.formReady ? (
                <SuKienDieuDongControl
                  key="d1"
                  disabled={this.state.dataSaved === undefined}
                  value={
                    this.state.DanhSachDieuDong[1] === undefined
                      ?( this.state.dataSaved !== undefined ? { ...this.state.dataSaved, ViTri: "" } : undefined)
                      : this.state.DanhSachDieuDong[1]
                  }
                  stt={1}
                  onSaved={(data) => {
                    var has = false;
                    this.state.DanhSachDieuDong[1] = data;
                    this.setState(this.state);
                  }}
                  allowAddMore={
                    this.state.DanhSachDieuDong[1] !== undefined &&
                    !this.state.DieuDong2
                  }
                  onAddMore={(stt) => {
                    this.setState({ DieuDong2: true });
                  }}
                  onChanged = {this.handleDataChanged}
                />
              ) : null}
              {this.state.DieuDong2 ? (
                <SuKienDieuDongControl
                  key="d2"
                  disabled={this.state.dataSaved === undefined}
                  value={
                    this.state.DanhSachDieuDong[2] === undefined
                      ? this.state.dataSaved
                      : this.state.DanhSachDieuDong[2]
                  }
                  stt={2}
                  onSaved={(data) => {
                    this.state.DanhSachDieuDong[2] = data;
                    this.setState(this.state);
                  }}
                  onRemoved={(stt) => {
                    //xoa control
                    this.setState({ DieuDong2: false });
                  }}
                  onChanged = {this.handleDataChanged}
                />
              ) : undefined}
              {this.state.formReady ? (
                <SuKienTrucBanControl
                  disabled={this.state.dataSaved === undefined}
                  value={this.state.dataSaved}
                  onChanged = {this.handleDataChanged}
                />
              ) : null}              
              {this.state.formReady ? (
                <SuKienKetQuaControl
                  disabled={this.state.dataSaved === undefined}
                  value={this.state.dataSaved}
                  onChanged = {this.handleDataChanged}
                />
              ) : null}
              {this.state.formReady ? (
                <SuKienKetQuaChiTietControl
                  disabled={this.state.dataSaved === undefined}
                  value={this.state.dataSaved}
                  onChanged = {this.handleDataChanged}
                />
              ) : null}
              {this.state.formReady ? (
                <SuKienDinhKemControl
                  disabled={this.state.dataSaved === undefined}
                  value={this.state.dataSaved}
                  savedFiles={this.state.DinhKem}
                />
              ) : null}
            </form>
            {this.state.errorLog === "" ? null : (
              <AlertDialog
                message={this.state.errorLog}
                callback={() => this.setState({ errorLog: "" })}
              />
            )}
            {this.state.showCloseConfirm ? (
              <ConfirmDialog
                message="Lưu ý: lưu lại dữ liệu trước khi thoát. Bạn vẫn muốn thoát ra ?"
                callback={(ok) => {
                  this.setState({ showCloseConfirm: false });
                  if (ok) {
                    this.handleClose(false);
                  }
                }}
              />
            ) : null}
          </DialogContent>
        </Dialog>
      </React.Fragment>
    );
  }
}
const styles = (theme) => ({
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  form: {
    display: "flex",
    flexDirection: "column",
    margin: "auto",
    width: "fit-content",
    heigh: "fit-content",
  },
  formControl: {
    marginTop: 2,
    minWidth: 120,
  },
  formControlLabel: {
    marginTop: 1,
  },
  paper: {},
  textField: {
    marginLeft: 1,
    marginRight: 1,
    width: 250,
  },
});
export default withStyles(styles, { withTheme: true })(SuKienEditDialog);
